module.exports = __webpack_public_path__ + "img/pickiddo.2a9ee2e4.png";